import isEmpty from 'lodash/isEmpty';
import { GLOBAL_STYLE } from 'src/constants/globalConfigs';
import { checkIfObjectExists } from 'src/utils/checkIfObjectExists';

export const getGLobalStyleEssentials = (globalConfig) => {
  const globalStyles =
    globalConfig && !isEmpty(globalConfig) ? globalConfig : { fonts: GLOBAL_STYLE.fonts };
  const fontStyles = globalStyles?.fonts;
  const fontURls: any = fontStyles
    ? Object.values(fontStyles)?.reduce<any>((acc, item: any) => {
        if (checkIfObjectExists(item)) {
          if (!acc.find((oldList) => oldList.fontCdn === item.fontCdn))
            acc.push({ fontFamily: item.fontFamily, fontCdn: item.fontCdn });
        }
        return acc;
      }, [])
    : [];
  if (!fontURls.length) {
    fontURls.push({
      fontFamily: 'Inter',
      fontCdn:
        'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
    });
  }

  return { fontURls, fontStyles };
};

export const getGlobalStyleString = ({ globalStyle }) => {
  const { fontURls, fontStyles } = getGLobalStyleEssentials(globalStyle);
  const { buttons = {}, imageCards = {}, inputs = {} } = globalStyle || {};

  const globalStyleString = `
  body {
  font-family: ${fontStyles?.isEnabled ? fontStyles?.body?.fontFamily : 'Inter'};
  letter-spacing: ${fontStyles?.isEnabled ? fontStyles?.body?.letterSpacing : ''};

  h1,h2,h3,h4,h5,h6{
    &:not(.removeGlobalOverride){
      font-family: ${fontStyles?.isEnabled ? fontStyles?.heading?.fontFamily : 'Inter'};
      letter-spacing: ${fontStyles?.isEnabled ? fontStyles?.body?.letterSpacing : ''};
      }
  }

  p {
    font-family: ${fontStyles?.isEnabled ? fontStyles?.body?.fontFamily : 'Inter'};
    letter-spacing: ${fontStyles?.isEnabled ? fontStyles?.body?.letterSpacing : ''};
  }

  ${
    fontStyles?.isEnabled
      ? `button {
            &:not(.removeGlobalOverride){
                font-family: ${fontStyles?.[fontStyles?.buttonInherit]?.fontFamily || 'Inter'};
                letter-spacing: ${fontStyles?.body?.letterSpacing || ''};
          }
      }
    `
      : ''
  }

  ${
    buttons?.isEnabled
      ? `button {
            &:not(.removeGlobalOverride){
            border-radius: ${buttons?.style?.borderRadius};
          }
        }`
      : ''
  };

  ${
    imageCards?.isEnabled
      ? `img, video{
      &:not(.removeGlobalOverride){
        border-start-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-start-end-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-end-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-end-end-radius: ${imageCards?.style?.borderRadius || '0px'};
      }

      .addTopLeftGlobalRadius{
        border-start-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-start-end-radius: unset;
        border-end-start-radius: unset;
        border-end-end-radius: unset;
      }

       .addTopRightGlobalRadius{
        border-start-start-radius:unset;
        border-start-end-radius:  ${imageCards?.style?.borderRadius || '0px'};
        border-end-start-radius: unset;
        border-end-end-radius: unset;
      }

       .addBottomLeftGlobalRadius{
        border-start-start-radius: unset;
        border-start-end-radius: unset;
        border-end-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-end-end-radius: unset;
      }

       .addBottomRightGlobalRadius{
        border-start-start-radius: unset;
        border-start-end-radius: unset;
        border-end-start-radius: unset;
        border-end-end-radius: ${imageCards?.style?.borderRadius || '0px'};
      }
  }
  .imgWrapperGlobalStyleMin{
      &:not(.removeGlobalOverride){
      border-start-start-radius: 20%;
      border-start-end-radius: 20%;
      border-end-start-radius: 20%;
      border-end-end-radius: 20%;
    }
  }

  .imgWrapperGlobalStyle{
      &:not(.removeGlobalOverride){
      border-start-start-radius: ${imageCards?.style?.borderRadius || '0px'};
      border-start-end-radius: ${imageCards?.style?.borderRadius || '0px'};
      border-end-start-radius: ${imageCards?.style?.borderRadius || '0px'};
      border-end-end-radius: ${imageCards?.style?.borderRadius || '0px'};
      }
        .addTopLeftGlobalRadius{
        border-start-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-start-end-radius: unset;
        border-end-start-radius: unset;
        border-end-end-radius: unset;
      }

       .addTopRightGlobalRadius{
        border-start-start-radius:unset;
        border-start-end-radius:  ${imageCards?.style?.borderRadius || '0px'};
        border-end-start-radius: unset;
        border-end-end-radius: unset;
      }

       .addBottomLeftGlobalRadius{
        border-start-start-radius: unset;
        border-start-end-radius: unset;
        border-end-start-radius: ${imageCards?.style?.borderRadius || '0px'};
        border-end-end-radius: unset;
      }

       .addBottomRightGlobalRadius{
        border-start-start-radius: unset;
        border-start-end-radius: unset;
        border-end-start-radius: unset;
        border-end-end-radius: ${imageCards?.style?.borderRadius || '0px'};
      }
    }`
      : ''
  }
  
  ${
    inputs?.isEnabled
      ? `input:not(.removeGlobalOverride){
          border-radius: ${inputs?.style?.borderRadius || '0px'};
      }`
      : ''
  }
  
}
`;

  return { globalStyleString, fontURls };
};

export const getSocialMediaLink = (storeMediaData) => {
  const mediaCount = storeMediaData?.media_count;
  if (!mediaCount) {
    return [];
  }
  const mediaData = storeMediaData?.media_detail;
  return mediaData.map((item) => item.profile_url).filter((url) => url !== '');
};
